import { FC, useEffect, useRef, useState } from "react";
import { OptionListProps } from "./types";
import { Column, Row } from "../containers";
import { Vec2 } from "../../types";
import { useThemeStore } from "../../stores";
import { Text } from "../typography";

const OptionList: FC<OptionListProps> = ({
  mousePos,
  options,
  props,
  className = "",
  style = {},
  background,
}) => {
  const theme = useThemeStore((s) => s.theme);

  const conRef = useRef<HTMLDivElement>(null);

  const [renderer, setRenderer] = useState<boolean>(false);

  const [pos, setPos] = useState<Vec2>({ x: 0, y: 0 });

  useEffect(() => {
    if (!mousePos.x && !mousePos.y) return;
    setPos({ ...mousePos });
    setRenderer(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mousePos.x, mousePos.y]);

  const hide = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    setRenderer(false);
  };

  useEffect(() => {
    if (!conRef.current || (!pos.x && !pos.y)) return;
    if (pos.y + conRef.current.clientHeight > window.innerHeight) {
      setPos((prev) => ({
        y: pos.y - conRef.current!.clientHeight ?? 0,
        x: prev.x,
      }));
    }
    if (pos.x + conRef.current.clientWidth > window.innerWidth) {
      setPos((prev) => ({
        y: prev.y,
        x: pos.x - conRef.current!.clientWidth ?? 0,
      }));
    }
  }, [conRef, pos.y, pos.x]);

  return (
    <Column
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        display: !renderer ? "none" : "flex",
        // background: "rgba(0, 0, 0, 0.5)",
        overflow: "hidden",
      }}
      props={{ onClick: hide }}
    >
      <Column
        containerRef={conRef}
        style={{
          position: "fixed",
          top: pos.y,
          left: pos.x,
          minWidth: 200,
          borderRadius: 7,
          zIndex: 9999,
          background: background || theme.background,
          boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
          ...style,
        }}
        props={props}
        className={className}
      >
        {options.map((opt) => (
          <Row
            key={opt.title}
            props={{ onClick: opt.onClick, ...opt.props }}
            className={opt.className}
            style={{
              width: "calc(100% - 1rem)",
              padding: "0.5rem",
              cursor: "pointer",
              ...opt.style,
            }}
            gap={30}
          >
            {opt.Icon ? (
              <opt.Icon color={opt.iconColor} />
            ) : (
              <div style={{ width: 16, height: 16 }}></div>
            )}
            <Text color={opt.color || theme.textOnBg}>{opt.title}</Text>
          </Row>
        ))}
      </Column>
    </Column>
  );
};

export default OptionList;
